export default "__VITE_ASSET__DQPuDG8M__"